<div class="p-d-flex p-flex-column p-ai-center p-jc-center gap-6">
  <div class="p-text-bold">
    Vaša sesija ističe uskoro. Da li želite da nastavite rad?
  </div>
  <div>{{ remainingTime }}</div>
</div>
